import React,{ Component } from 'react';
import { Row, Col } from 'reactstrap';


class HelpFAQs extends Component {
  render(){
    return (
      <div>
        <Row>
          <Col xs='12'>
            <br />
            <h4>What is Dabbl?</h4>
            <p>
              Downtime Dollars is a secure mobile media network that directly connects consumers with their favorite brands. Consumers are rewarded with ‘dollars-off anything’ for sharing their time, data, and brand loyalty. Retailer participation may vary depending on the consumer’s location.
            </p>
            <br />
            <hr />
            <br />
            <h2>User Management</h2>
            <br />
            <h4>What is the difference between a ‘Creator’ and an ‘Admin’ user role?</h4>
            <p>
              A ‘Creator’ can create and edit experiences and brand information. In addition to these abilities, an ‘Admin’ can also approve experiences for launch and manage users on an account.
            </p>
            <h4>How do I create additional user profiles?</h4>
            <ul>
              <li>Log in to the Downtime Dollars ad manager as an ‘Admin’ user</li>
              <li>On the home page, select the settings dropdown on the top right of the navigation bar and then ‘Manage Team’ </li>
              <li>On the ‘Manage Team’ screen, click ‘Invite User’</li>
              <li>Enter the contact information for the new user and select the role:</li>
              <ul>
                <li>A ‘Creator’ user can create and edit experiences and brand information</li>
                <li>An ‘Admin’ user can create and edit experiences and brand information, approve experiences, and manage users</li>
              </ul>
              <li>Click ‘Invite’</li>
            </ul>
            <h4>How do I edit user information?</h4>
            <ul>
              <li>Log in to the Downtime Dollars ad manager as an ‘Admin’ user</li>
              <li>On the home page, select the settings dropdown on the top right of the navigation bar and then ‘Manage Team’ </li>
              <li>On the ‘Manage Team’ screen, select the name of the profile you would like to edit</li>
              <li>Edit the information on the ‘Edit Profile’ screen</li>
              <li>Click ‘Update’</li>
            </ul>
            <h4>How do I change the status of an existing user? </h4>
            <p>
              If you would like deactivate an existing user that will no longer be using the Ad Manager or if you’d like to activate a previously deactivated user, follow these steps:
            </p>
            <ul>
              <li>Log in to the Downtime Dollars ad manager as an ‘Admin’ user</li>
              <li>On the home page, select the settings dropdown on the top right of the navigation bar and then ‘Manage Team’ </li>
              <li>From the ‘Manage Team’ screen, select the appropriate status (Deactivate or Activate) next to the user who’s status you would like to modify</li>
            </ul>
            <br />
            <hr />
            <br />
            <h2>Experiences</h2>
            <br />
            <h4>How do I create an experience?</h4>
            <ul>
              <li>Select ‘Create Experience' from the Downtime Dollars ad manager home page</li>
              <li>Update the following information to submit the experience for approval:</li>
              <ul>
                <li>Define the experience (name, brand, dates, budget, etc.)</li>
                <li>Create the experience tile</li>
                <li>Create activities (one or more)</li>
                <li>Define a conclusion message</li>
                <li>Review setup details</li>
                <li>Click ‘Submit for Approval’ once all details are final. This will kick off Dabbl’s quick approval process which includes approval from your account Admin and then a Downtime Dollars reviewer.</li>
              </ul>
              <li>Reach out to your Downtime Dollars sales contact to set a budget and set up and manage payment information</li>
            </ul>
            <h4>What is an activity?</h4>
            <p>
              An activity is an event consumers complete as they interact with your experience.
            </p>
            <h4>What is the max number of activities I can add to an experience?</h4>
            <p>
              You may add an unlimited number of activities to an experience, however, Downtime Dollars suggests including 4-6 activities for the best consumer experience.
            </p>
            <h4>Can I change the order of activities?</h4>
            <p>
              Yes. Changes can be made to your activities prior to the approval of your experience. To change the order of an activity:
            </p>
            <ul>
              <li>From ‘Edit Experience' screen, press the up or down arrow on the top right of the activity card you’d like to move</li>
              <li>Click Click 'Save for later' or 'Next: review & submit' to finalize changes.</li>
            </ul>
            <h4>I’ve created an experience, now what?</h4>
            <p>
              After you have entered and finalized your experience details and pressed ‘Submit for Approval,’ an experience will go through 2 reviews. Experiences are reviewed and approved by an account ‘Admin’ and then a Downtime Dollars team member before becoming ‘Active’ on the start date. The status of an experience is updated automatically as an experience goes through the various stages from submission to launch. Once an experience is launched you may view experience responses in real time.
            </p>
            <h4>How do I know my experience is live?</h4>
            <p>
              You will know your experience is live if it is showing as ‘Active’ status.
            </p>
            <h4>What is the life cycle of an experience?</h4>
            <p>
              On the home page you will see a list of your experiences that may be in various stages of setup. A typical experience will cycle through the following statuses in its life cycle:
            </p>
            <ol>
              <li>
                <strong>Draft</strong> - An experience is still being edited and has not yet been submitted for approval
              </li>
              <li>
                <strong>Pending Admin Approval</strong> - Your account ‘Admin’ is reviewing the experience for approval
              </li>
              <li>
                <strong>Pending Downtime Dollars Approval</strong> - A Downtime Dollars team member is reviewing the experience for approval
              </li>
              <li>
                <strong>Ready</strong> - Experience has been approved by your account ‘Admin’ and a Downtime Dollars team member, but the start date has not passed
              </li>
              <li>
                <strong>Active</strong> - Experience has been approved by your account ‘Admin’ and a Downtime Dollars team member and your experience is live on the Dabbl network
              </li>
              <li>
                <strong>Completed</strong> - Experience has met its budget or the end date and is no longer live on the Downtime Dollars network
              </li>
            </ol>
            <br />
            <hr />
            <br />
            <h2>Brands</h2>
            <br />
            <h4>How do I create brands?</h4>
            <ul>
              <li>From the home screen, click on the ‘Brands’ link on the top of the page or select ‘Manage Brands’ from the settings dropdown on the top right of the navigation bar</li>
              <li>Once on the ‘Manage Brands’ screen, select ‘New Brand’ to enter your brand details including the brand name, color and logo</li>
              <li>Click ‘Create’</li>
            </ul>
            <h4>How do I edit an existing brand?</h4>
            <ul>
              <li>From the home screen, click on the ‘Brands’ link on the top of the page or select ‘Manage Brands’ from the settings dropdown on the top right of the navigation bar</li>
              <li>On the ‘Manage Brands’ screen, select the name of the brand you would like to edit</li>
              <li>Edit brand as necessary </li>
              <li>Click ‘Update’ to save changes</li>
            </ul>
            <h4>How do I change the status of an existing brand? </h4>
            <p>If you would like 'Deactivate' an existing brand that you will no longer be using or if you would like to ‘Activate’ a previously 'Deactivated' brand, follow these steps:</p>
            <ul>
              <li>From the home screen, click on the ‘Brands’ link on the top of the page or select ‘Manage Brands’ from the settings dropdown on the top right of the navigation bar</li>
              <li>On the ‘Manage Brands’ screen, select the ‘Deactivate’ or ‘Activate’ button next to the brand you would like to modify</li>
            </ul>
            <br />
            <hr />
            <br />
            <h2>Results</h2>
            <br />
            <h4>How is average rating determined?</h4>
            <p>
              Every time a consumer completes an experience, the consumer rates how much they enjoyed it, varying from a very happy emoji face to a very sad one. Later, we display this average to you at an account, brand and experience level so you can understand how consumers are evaluating their time with you.
            </p>
            <h4>Can I see consumer responses to my experience in real-time?</h4>
            <p>You can view your experience response summaries at any time after your experience is active. To view results:</p>
            <ul>
              <li>Sign into the Downtime Dollars ad manager </li>
              <li>From the experience list, identify the experience for which you would like to view results and press the ‘Results’ button to the far right</li>
            </ul>
            <h4>Do you allow impression tags?</h4>
            <p>
              Yes. We support DCM tags or other vendor tracking tags with the following formats: Javascript, iFrame, and Image tags. During experience setup, you may associate one or more impression tags to media for each activity as well as the cover tile that displays on the app home screen.
            </p>
            <h4>Do you allow viewability measurement tags?</h4>
            <p>
              Yes. We support DoubleVerify tags, with more vendors coming soon. During experience setup, you may add one or more viewability tags to media for each activity as well as the cover tile that displays on the app home screen.
            </p>
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default HelpFAQs;



// WEBPACK FOOTER //
// ./src/routes/HelpFAQs/components/HelpFAQs.js